import { BaseCamelCasedResource } from "../resources/BaseResource";
import { legacyApiResourceUrl, apiResourceUrl } from "@ploy-lib/core";
class LinkItemResource extends BaseCamelCasedResource {
    constructor() {
        super(...arguments);
        this.disabled = false;
        this.linkPublic = false;
        this.sortOrder = 0;
    }
    pk() {
        return `${this.linkId}`;
    }
    static linksForVendor() {
        return this.list().extend({
            url: (params) => legacyApiResourceUrl("Information/GetLinksForVendor")
        });
    }
    static productInfoForUser() {
        return this.list().extend({
            url: (params) => legacyApiResourceUrl("Product/GetProductInfoForUser")
        });
    }
}
LinkItemResource.urlRoot = apiResourceUrl("links");
export { LinkItemResource };
//# sourceMappingURL=LinkItemResource.js.map